import { GITHUB_WORKFLOW_FILE_PATH } from "@constants";

import { CronFrequency, GhaOptions } from "../types";

export const PRODUCTION_PUBLISH_URL = "https://semgrep.dev";

export const frequencyToPOSIXcronsyntax = {
  daily: "0 0 * * *",
  weekly: "0 0 * * 0",
};

export const DEFAULT_GHA_OPTIONS: GhaOptions = {
  prEnabled: true,
  prSendComments: true,
  pushEnabled: true,
  pushBranches: ["main", "master"],
  pushPaths: [GITHUB_WORKFLOW_FILE_PATH],
  cronEnabled: true,
  cronSchedule: CronFrequency.weekly,
  publishUrl: PRODUCTION_PUBLISH_URL,
};
